import * as z from 'zod';

export const CreateCollectionMetadataRequest = z.object({
  collectionMetadata: z
    .object({
      dataCollectionId: z
        .string()
        .describe('ID of the associated data collection.')
        .max(256)
        .optional(),
      activeNamedViewId: z
        .string()
        .describe(
          'ID of the active named (custom) view. Learn more about [creating custom collection views](https://support.wix.com/en/article/cms-creating-custom-collection-views) in the CMS.'
        )
        .max(1024)
        .optional()
        .nullable(),
      hideTableView: z
        .boolean()
        .describe(
          'Whether to [hide the table layout view](https://support.wix.com/en/article/cms-setting-field-validations-in-your-collections#hiding-the-table-layout-to-prevent-empty-required-fields). Default: `false`.'
        )
        .optional()
        .nullable(),
      namedViews: z.array(z.record(z.string(), z.any())).max(1000).optional(),
      namedViewIdForSiteSort: z
        .string()
        .describe(
          "Custom view to mirror on the Wix site. Learn more about [mirroring item order to the site's connected elements](https://support.wix.com/en/article/cms-mirroring-the-order-of-items-in-your-collection-to-your-sites-connected-elements)."
        )
        .max(1024)
        .optional()
        .nullable(),
      permissionsTemplate: z
        .enum(['UNDEFINED', 'SHOW_CONTENT', 'COLLECT_CONTENT', 'CUSTOM'])
        .optional(),
    })
    .describe('Collection metadata details.'),
});
export const CreateCollectionMetadataResponse = z.object({
  dataCollectionId: z
    .string()
    .describe('ID of the associated data collection.')
    .max(256)
    .optional(),
  activeNamedViewId: z
    .string()
    .describe(
      'ID of the active named (custom) view. Learn more about [creating custom collection views](https://support.wix.com/en/article/cms-creating-custom-collection-views) in the CMS.'
    )
    .max(1024)
    .optional()
    .nullable(),
  hideTableView: z
    .boolean()
    .describe(
      'Whether to [hide the table layout view](https://support.wix.com/en/article/cms-setting-field-validations-in-your-collections#hiding-the-table-layout-to-prevent-empty-required-fields). Default: `false`.'
    )
    .optional()
    .nullable(),
  namedViews: z.array(z.record(z.string(), z.any())).max(1000).optional(),
  namedViewIdForSiteSort: z
    .string()
    .describe(
      "Custom view to mirror on the Wix site. Learn more about [mirroring item order to the site's connected elements](https://support.wix.com/en/article/cms-mirroring-the-order-of-items-in-your-collection-to-your-sites-connected-elements)."
    )
    .max(1024)
    .optional()
    .nullable(),
  permissionsTemplate: z
    .enum(['UNDEFINED', 'SHOW_CONTENT', 'COLLECT_CONTENT', 'CUSTOM'])
    .describe(
      'Collection permission template. Each collection has a permissions template that determines what Learn more about [collection permissions](https://support.wix.com/en/article/cms-changing-your-collection-permissions).'
    )
    .optional(),
});
export const GetCollectionMetadataRequest = z.object({
  dataCollectionId: z
    .string()
    .describe('ID of the collection for which to retrieve metadata.')
    .max(256),
});
export const GetCollectionMetadataResponse = z.object({
  dataCollectionId: z
    .string()
    .describe('ID of the associated data collection.')
    .max(256)
    .optional(),
  activeNamedViewId: z
    .string()
    .describe(
      'ID of the active named (custom) view. Learn more about [creating custom collection views](https://support.wix.com/en/article/cms-creating-custom-collection-views) in the CMS.'
    )
    .max(1024)
    .optional()
    .nullable(),
  hideTableView: z
    .boolean()
    .describe(
      'Whether to [hide the table layout view](https://support.wix.com/en/article/cms-setting-field-validations-in-your-collections#hiding-the-table-layout-to-prevent-empty-required-fields). Default: `false`.'
    )
    .optional()
    .nullable(),
  namedViews: z.array(z.record(z.string(), z.any())).max(1000).optional(),
  namedViewIdForSiteSort: z
    .string()
    .describe(
      "Custom view to mirror on the Wix site. Learn more about [mirroring item order to the site's connected elements](https://support.wix.com/en/article/cms-mirroring-the-order-of-items-in-your-collection-to-your-sites-connected-elements)."
    )
    .max(1024)
    .optional()
    .nullable(),
  permissionsTemplate: z
    .enum(['UNDEFINED', 'SHOW_CONTENT', 'COLLECT_CONTENT', 'CUSTOM'])
    .describe(
      'Collection permission template. Each collection has a permissions template that determines what Learn more about [collection permissions](https://support.wix.com/en/article/cms-changing-your-collection-permissions).'
    )
    .optional(),
});
export const UpdateCollectionMetadataRequest = z.object({
  dataCollectionId: z
    .string()
    .describe(
      "TODO CLARIFY WHAT THIS MEANS:\nID of metadata to update, ignored if **collection_metadata.data_collection_id** is non-empty // a technical workaround\nexists because of docs generation issue with nested fields and ** path variables\nTODO shouldn't this be required? // Yes\nID of the collection for which to update metadata."
    )
    .max(256),
  collectionMetadata: z
    .object({
      dataCollectionId: z
        .string()
        .describe('ID of the associated data collection.')
        .max(256)
        .optional(),
      activeNamedViewId: z
        .string()
        .describe(
          'ID of the active named (custom) view. Learn more about [creating custom collection views](https://support.wix.com/en/article/cms-creating-custom-collection-views) in the CMS.'
        )
        .max(1024)
        .optional()
        .nullable(),
      hideTableView: z
        .boolean()
        .describe(
          'Whether to [hide the table layout view](https://support.wix.com/en/article/cms-setting-field-validations-in-your-collections#hiding-the-table-layout-to-prevent-empty-required-fields). Default: `false`.'
        )
        .optional()
        .nullable(),
      namedViews: z.array(z.record(z.string(), z.any())).max(1000).optional(),
      namedViewIdForSiteSort: z
        .string()
        .describe(
          "Custom view to mirror on the Wix site. Learn more about [mirroring item order to the site's connected elements](https://support.wix.com/en/article/cms-mirroring-the-order-of-items-in-your-collection-to-your-sites-connected-elements)."
        )
        .max(1024)
        .optional()
        .nullable(),
      permissionsTemplate: z
        .enum(['UNDEFINED', 'SHOW_CONTENT', 'COLLECT_CONTENT', 'CUSTOM'])
        .optional(),
    })
    .describe(
      'Collection metadata to update. Only the specified fields are affected. Fields not mentioned remain unchanged.'
    ),
});
export const UpdateCollectionMetadataResponse = z.object({
  dataCollectionId: z
    .string()
    .describe('ID of the associated data collection.')
    .max(256)
    .optional(),
  activeNamedViewId: z
    .string()
    .describe(
      'ID of the active named (custom) view. Learn more about [creating custom collection views](https://support.wix.com/en/article/cms-creating-custom-collection-views) in the CMS.'
    )
    .max(1024)
    .optional()
    .nullable(),
  hideTableView: z
    .boolean()
    .describe(
      'Whether to [hide the table layout view](https://support.wix.com/en/article/cms-setting-field-validations-in-your-collections#hiding-the-table-layout-to-prevent-empty-required-fields). Default: `false`.'
    )
    .optional()
    .nullable(),
  namedViews: z.array(z.record(z.string(), z.any())).max(1000).optional(),
  namedViewIdForSiteSort: z
    .string()
    .describe(
      "Custom view to mirror on the Wix site. Learn more about [mirroring item order to the site's connected elements](https://support.wix.com/en/article/cms-mirroring-the-order-of-items-in-your-collection-to-your-sites-connected-elements)."
    )
    .max(1024)
    .optional()
    .nullable(),
  permissionsTemplate: z
    .enum(['UNDEFINED', 'SHOW_CONTENT', 'COLLECT_CONTENT', 'CUSTOM'])
    .describe(
      'Collection permission template. Each collection has a permissions template that determines what Learn more about [collection permissions](https://support.wix.com/en/article/cms-changing-your-collection-permissions).'
    )
    .optional(),
});
export const ReplaceCollectionMetadataRequest = z.object({
  options: z
    .object({
      items: z
        .array(
          z.object({
            dataCollectionId: z
              .string()
              .describe('ID of the associated data collection.')
              .max(256)
              .optional(),
            activeNamedViewId: z
              .string()
              .describe(
                'ID of the active named (custom) view. Learn more about [creating custom collection views](https://support.wix.com/en/article/cms-creating-custom-collection-views) in the CMS.'
              )
              .max(1024)
              .optional()
              .nullable(),
            hideTableView: z
              .boolean()
              .describe(
                'Whether to [hide the table layout view](https://support.wix.com/en/article/cms-setting-field-validations-in-your-collections#hiding-the-table-layout-to-prevent-empty-required-fields). Default: `false`.'
              )
              .optional()
              .nullable(),
            namedViews: z
              .array(z.record(z.string(), z.any()))
              .max(1000)
              .optional(),
            namedViewIdForSiteSort: z
              .string()
              .describe(
                "Custom view to mirror on the Wix site. Learn more about [mirroring item order to the site's connected elements](https://support.wix.com/en/article/cms-mirroring-the-order-of-items-in-your-collection-to-your-sites-connected-elements)."
              )
              .max(1024)
              .optional()
              .nullable(),
            permissionsTemplate: z
              .enum(['UNDEFINED', 'SHOW_CONTENT', 'COLLECT_CONTENT', 'CUSTOM'])
              .optional(),
          })
        )
        .max(1000)
        .optional(),
    })
    .optional(),
});
export const ReplaceCollectionMetadataResponse = z.object({});
export const DeleteCollectionMetadataRequest = z.object({
  dataCollectionId: z
    .string()
    .describe('ID of the collection for which to delete metadata.')
    .max(256),
});
export const DeleteCollectionMetadataResponse = z.object({});
export const ListCollectionMetadataRequest = z.object({
  options: z
    .object({
      paging: z
        .object({
          limit: z
            .number()
            .int()
            .describe('Maximum number of items to return in the results.')
            .min(0)
            .max(100)
            .optional()
            .nullable(),
          cursor: z
            .string()
            .describe(
              "Pointer to the next or previous page in the list of results.\n\nPass the relevant cursor token from the `pagingMetadata` object in the previous call's response.\nNot relevant for the first request."
            )
            .max(16000)
            .optional()
            .nullable(),
        })
        .describe('Paging settings.')
        .optional(),
    })
    .optional(),
});
export const ListCollectionMetadataResponse = z.object({
  items: z
    .array(
      z.object({
        dataCollectionId: z
          .string()
          .describe('ID of the associated data collection.')
          .max(256)
          .optional(),
        activeNamedViewId: z
          .string()
          .describe(
            'ID of the active named (custom) view. Learn more about [creating custom collection views](https://support.wix.com/en/article/cms-creating-custom-collection-views) in the CMS.'
          )
          .max(1024)
          .optional()
          .nullable(),
        hideTableView: z
          .boolean()
          .describe(
            'Whether to [hide the table layout view](https://support.wix.com/en/article/cms-setting-field-validations-in-your-collections#hiding-the-table-layout-to-prevent-empty-required-fields). Default: `false`.'
          )
          .optional()
          .nullable(),
        namedViews: z.array(z.record(z.string(), z.any())).max(1000).optional(),
        namedViewIdForSiteSort: z
          .string()
          .describe(
            "Custom view to mirror on the Wix site. Learn more about [mirroring item order to the site's connected elements](https://support.wix.com/en/article/cms-mirroring-the-order-of-items-in-your-collection-to-your-sites-connected-elements)."
          )
          .max(1024)
          .optional()
          .nullable(),
        permissionsTemplate: z
          .enum(['UNDEFINED', 'SHOW_CONTENT', 'COLLECT_CONTENT', 'CUSTOM'])
          .describe(
            'Collection permission template. Each collection has a permissions template that determines what Learn more about [collection permissions](https://support.wix.com/en/article/cms-changing-your-collection-permissions).'
          )
          .optional(),
      })
    )
    .optional(),
  pagingMetadata: z
    .object({
      count: z
        .number()
        .int()
        .describe('Number of items returned in current page.')
        .optional()
        .nullable(),
      cursors: z
        .object({
          next: z
            .string()
            .describe(
              'Cursor string pointing to the next page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
          prev: z
            .string()
            .describe(
              'Cursor pointing to the previous page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
        })
        .describe(
          'Cursor strings that point to the next page, previous page, or both.'
        )
        .optional(),
      hasNext: z
        .boolean()
        .describe(
          'Whether there are more pages to retrieve following the current page.\n\n+ `true`: Another page of results can be retrieved.\n+ `false`: This is the last page.'
        )
        .optional()
        .nullable(),
    })
    .describe('Paging information.')
    .optional(),
});
